/*
* Pipeline Theme — custom.js
*
* IMPORTANT:
* 1) This file must be enabled in layout/theme.liquid (uncomment the custom.js import).
* 2) Do NOT put <script> tags in this file.
*/

/* --- Polyfills to make 3rd-party code safer --- */
(function(){
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s){ return [].indexOf.call((this.document || this.ownerDocument).querySelectorAll(s), this) !== -1; };
  }
  // Allow `.closest` calls on *any* node (even Text/Document)
  if (typeof Node !== 'undefined' && !Node.prototype.closest) {
    Node.prototype.closest = function(selector){
      var el = (this.nodeType === 1 ? this : this.parentElement);
      while (el && el.nodeType === 1) {
        if (el.matches(selector)) return el;
        el = el.parentElement;
      }
      return null;
    };
  }
})();

(function() {
  'use strict';

  // Safe closest helper (handles text nodes & non-elements)
  function _closest(start, selector){
    var t = start;
    if (t && t.nodeType === 3) t = t.parentElement; // normalize text nodes
    if (!t || typeof t.closest !== 'function') return null;
    return t.closest(selector);
  }

  // ---------------------------------------------------------------------------
  // Pipeline example listeners (safe to keep; you can remove if noisy)
  // ---------------------------------------------------------------------------
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail && event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
  });

  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // ---------------------------------------------------------------------------
  // Default “Available” filter without showing it in the URL
  // ---------------------------------------------------------------------------
  function scrubAvailability(u) {
    try {
      const url = new URL(u, window.location.origin);
      if (url.searchParams.get('filter.v.availability') === '1') {
        url.searchParams.delete('filter.v.availability');
      }
      return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
    } catch (e) {
      return location.pathname + location.search;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // If the page initially loads with the param, hide it immediately.
    if (new URL(location.href).searchParams.get('filter.v.availability') === '1') {
      history.replaceState({}, '', scrubAvailability(location.href));
    }
  });

  // Ensure every filter/sort submit includes availability=1, then scrub it from the address bar.
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && form.matches && form.matches('form[action*="/collections/"], form[action*="/search"], form[data-sidebar-filter-form]')) {
      let hidden = form.querySelector('input[name="filter.v.availability"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'filter.v.availability';
        hidden.value = '1';
        form.appendChild(hidden);
      } else {
        hidden.value = '1';
      }
      setTimeout(() => history.replaceState({}, '', scrubAvailability(location.href)), 0);
    }
  }, true);

  window.addEventListener('popstate', () => {
    history.replaceState({}, '', scrubAvailability(location.href));
  });

  // ---------------------------------------------------------------------------
  // Swap grid images from sibling swatches — robust
  // ---------------------------------------------------------------------------
  (function () {
    function decode(s){
      if(!s) return '';
      var el=document.createElement('textarea'); el.innerHTML=s; return el.value;
    }
    function setSelected(btn){
      var list = _closest(btn, '.pg-siblings');
      if (!list) return;
      var actives = list.querySelectorAll('.pg-siblings__link[aria-current="true"]');
      for (var i=0;i<actives.length;i++) actives[i].removeAttribute('aria-current');
      btn.setAttribute('aria-current','true');
    }
    function ensureRealImg(wrap){
      if (!wrap) return null;
      var tpl = wrap.querySelector('template');
      if (tpl) wrap.innerHTML = '';
      var img = wrap.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.className = 'product-grid-item__image';
        img.decoding='async';
        wrap.appendChild(img);
      }
      return img;
    }
    function putInTemplate(wrap, url, srcset){
      if (!wrap) return;
      wrap.innerHTML = '';
      var tpl = document.createElement('template');
      var img = document.createElement('img');
      img.className = 'product-grid-item__image';
      if (url) img.src = url;
      if (srcset) img.srcset = decode(srcset);
      img.loading = 'lazy';
      img.decoding = 'async';
      tpl.content.appendChild(img);
      wrap.appendChild(tpl);
    }

    function setCardTitle(card, title){
      if (!title) return;
      var t = card.querySelector('.product__grid__title');
      if (t) t.textContent = title;

      var v = card.querySelector('product-grid-item-variant.product-grid-item__content');
      if (v) v.setAttribute('aria-label', title);

      // NOTE: your current markup has .pg-media-wrap then <a>, so this selector may not match.
      // We'll update BOTH the media link and info link if found.
      var linkMain = card.querySelector('.pg-media-wrap > a[data-grid-link]') ||
                     card.querySelector('.product-grid-item__container > a[data-grid-link]');
      if (linkMain) linkMain.setAttribute('aria-label', title);

      var linkInfo = card.querySelector('.product__grid__info > a');
      if (linkInfo) linkInfo.setAttribute('aria-label', title);
    }

    function setCardPrice(card, html, available){
      var priceBox = card.querySelector('.product__grid__price');
      if (priceBox && html) priceBox.innerHTML = html;

      var soldEl = card.querySelector('.product__grid__price__sold');
      var isAvail = !(String(available) === 'false' || String(available) === '0');
      if (soldEl){
        if (isAvail){
          soldEl.hidden = true;
          soldEl.style.display = 'none';
        } else {
          soldEl.hidden = false;
          soldEl.style.display = '';
        }
      }
    }

    function swapFrom(btn){
      var card   = _closest(btn, 'product-grid-item, .product-grid-item'); if (!card) return;
      var images = card.querySelector('.product-grid-item__images');        if (!images) return;

      var primary =
        images.querySelector('product-grid-item-image.is-active, .product-grid-item__image-wrapper.is-active') ||
        images.querySelector('product-grid-item-image, .product-grid-item__image-wrapper');

      var slides = images.querySelectorAll('product-grid-item-image, .product-grid-item__image-wrapper');
      var hover  = images.querySelector('[data-grid-image="1"]') || slides[1] || null;

      var img1 = btn.getAttribute('data-img1') || '';
      var set1 = decode(btn.getAttribute('data-img1-srcset') || btn.dataset.img1Srcset || '');
      var img2 = btn.getAttribute('data-img2') || '';
      var set2 = decode(btn.getAttribute('data-img2-srcset') || btn.dataset.img2Srcset || '');

      // Swap visible image
      if (primary && img1){
        var el = ensureRealImg(primary);
        if (el){
          el.src = img1;
          if (set1){ el.srcset = set1; el.sizes='(min-width: 990px) 33vw, 50vw'; }
          else { el.removeAttribute('srcset'); }
          el.loading = 'eager';
        }
      }

      // Swap hover slide
      if (hover){
        if (img2) putInTemplate(hover, img2, set2);
        else hover.innerHTML = '';
      }

      // Keep first slide active
      for (var i=0;i<slides.length;i++){
        if (slides[i] && slides[i].classList) slides[i].classList.toggle('is-active', i === 0);
      }

      // Update links to selected sibling
      var targetUrl = decode(btn.getAttribute('data-url') || btn.dataset.url || '');
      var handle    = btn.getAttribute('data-handle') || btn.dataset.handle || '';
      var dest      = targetUrl || (handle ? '/products/'+handle : '');

      if (dest){
        var linkMain = card.querySelector('.pg-media-wrap > a[data-grid-link]') ||
                       card.querySelector('.product-grid-item__container > a[data-grid-link]');
        if (linkMain) linkMain.href = dest;

        var linkInfo = card.querySelector('.product__grid__info > a');
        if (linkInfo) linkInfo.href = dest;

        if (handle) card.setAttribute('data-product-handle', handle);
      }

      // Mark selected chip
      setSelected(btn);

      // Update title
      var titleFromBtn = decode(btn.getAttribute('data-title') || '');
      if (titleFromBtn) {
        setCardTitle(card, titleFromBtn);
      } else if (handle) {
        fetch('/products/' + handle + '.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(p){ if (p && p.title) setCardTitle(card, p.title); })
          .catch(function(){});
      }

      // Update price/sold
      var priceHtml = btn.getAttribute('data-price-html') || '';
      var availAttr = btn.getAttribute('data-available');
      setCardPrice(card, priceHtml, availAttr);

      // Notify Quick Add
      try {
        document.dispatchEvent(new CustomEvent('qa:update', { detail: { card: card, handle: handle } }));
      } catch(_e){}
    }

    // Click swatches
    var SEL = '.pg-siblings__link, [data-pg-sibling], .swatch__link';
    ['click','pointerdown','touchstart'].forEach(function(evt){
      document.addEventListener(evt, function(e){
        var btn = _closest(e.target, SEL);
        if (!btn) return;
        e.preventDefault();
        swapFrom(btn);
      }, false);
    });

    // Limit Pipeline hover swap to image area only (avoid flicker)
    document.addEventListener('mouseover', function (e) {
      var card = _closest(e.target, '.product-grid-item, product-grid-item');
      if (!card) return;
      if (!_closest(e.target, '.product-grid-item__images')) {
        e.stopImmediatePropagation();
      }
    }, true);
  })();

  // ---------------------------------------------------------------------------
  // Quick Add: desktop = chips on hover; mobile = FAB toggles chips
  // Works with markup:
  //   .pg-media-wrap contains .qa-fab + .qa-overlay[data-qa-overlay]
  // and card has data-product-handle updated by sibling swap.
  // ---------------------------------------------------------------------------
  (function(){
    const productCache = new Map();

    async function getProduct(handle){
      if (productCache.has(handle)) return productCache.get(handle);
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Product JSON not found');
      const json = await res.json();
      productCache.set(handle, json);
      return json;
    }

    async function addToCart(variantId, qty=1){
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) {
        // Try to parse Shopify error
        let msg = 'Add to cart failed';
        try {
          const j = await res.json();
          msg = j && (j.description || j.message) ? (j.description || j.message) : msg;
        } catch(_e){}
        throw new Error(msg);
      }
      const added = await res.json();

      // Nudge Pipeline / theme listeners (harmless if unused)
      try { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); } catch(_e){}
      try { document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { added: added } })); } catch(_e){}

      return added;
    }

    // Close all open overlays except for an optional card
    function closeOverlaysExcept(card){
      document.querySelectorAll('.qa-overlay:not([hidden])').forEach(ov=>{
        const wrap = ov.closest('.pg-media-wrap');
        const fab  = wrap ? wrap.querySelector('.qa-fab') : null;
        const thisCard = wrap ? wrap.closest('product-grid-item, .product-grid-item') : null;
        if (card && thisCard === card) return;

        ov.hidden = true; ov.style.opacity=''; ov.style.transform='';
        if (fab){ fab.setAttribute('aria-expanded','false'); fab.hidden = false; }
      });
    }

    function renderChips(overlay, p){
      overlay.innerHTML = '';

      // Prefer "Size" option, else first option
      const idx = Math.max(0, (p.options || []).findIndex(o => /size/i.test(o)));

      // Build unique labels in declared order
      const labels = [];
      const seen = new Set();
      (p.variants || []).forEach(v => {
        const key = (v.options && v.options[idx]) ? v.options[idx] : v.title;
        if (!seen.has(key)) { seen.add(key); labels.push(key); }
      });

      let count = 0;
      labels.forEach(label => {
        const vAvail = (p.variants || []).find(v =>
          (v.options && v.options[idx]) === label && v.available
        );
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qa-chip';
        btn.textContent = String(label).toUpperCase();
        if (vAvail) btn.dataset.variantId = String(vAvail.id);
        else btn.disabled = true;
        overlay.appendChild(btn);
        count++;
      });

      overlay.dataset.ready = count ? '1' : '0';
      overlay.dataset.handleUsed = p.handle;
      overlay.dataset.count = String(count);
      return count > 0;
    }

    async function openOverlayForCard(card){
      if (!card) return;
      closeOverlaysExcept(card);

      const wrap    = card.querySelector('.pg-media-wrap');
      const overlay = wrap ? wrap.querySelector('[data-qa-overlay]') : null;
      const fab     = wrap ? wrap.querySelector('.qa-fab') : null;
      const handle  = card.getAttribute('data-product-handle');
      if (!wrap || !overlay || !handle) return;

      if (overlay.dataset.ready !== '1' || overlay.dataset.handleUsed !== handle){
        const p = await getProduct(handle);
        renderChips(overlay, p);
      }

      overlay.hidden = false;
      overlay.style.opacity = '1';
      overlay.style.transform = 'none';
      if (fab){ fab.setAttribute('aria-expanded','true'); fab.hidden = true; }
    }

    // Rebuild sizes when a sibling is selected (fired by swap script)
    document.addEventListener('qa:update', async (e)=>{
      const d = e.detail || {};
      const card = d.card;
      const handle = d.handle;
      if (!card || !handle) return;

      const wrap    = card.querySelector('.pg-media-wrap');
      const overlay = wrap ? wrap.querySelector('[data-qa-overlay]') : null;
      const fab     = wrap ? wrap.querySelector('.qa-fab') : null;
      if (!overlay) return;

      overlay.hidden = true;
      overlay.dataset.ready = '0';
      overlay.innerHTML = '';
      if (fab){ fab.setAttribute('aria-expanded','false'); fab.hidden = false; }

      try{
        const p = await getProduct(handle);
        renderChips(overlay, p);
      }catch(_e){}
    });

    // Desktop: prebuild on first hover over wrapper
    document.addEventListener('mouseenter', async (e)=>{
      const wrap = _closest(e.target, '.pg-media-wrap');
      if (!wrap) return;
      const overlay = wrap.querySelector('[data-qa-overlay]');
      if (!overlay || overlay.dataset.ready === '1') return;

      const card   = wrap.closest('product-grid-item, .product-grid-item');
      const handle = card && card.getAttribute('data-product-handle');
      if (!handle) return;

      try{
        const p = await getProduct(handle);
        renderChips(overlay, p);
      }catch(_e){}
    }, true);

    // Mobile FAB: open on pointerdown/click/touchend (covers iOS)
    (function(){
      function openFab(e){
        const btn = _closest(e.target, '[data-quick-add]');
        if (!btn) return;

        // Prevent navigation if anything tries to route this click
        e.preventDefault();

        // De-dupe across multiple events
        if (btn.__qaOpening) return;
        btn.__qaOpening = true;
        setTimeout(()=>{ btn.__qaOpening = false; }, 180);

        const card = _closest(btn, 'product-grid-item, .product-grid-item');
        openOverlayForCard(card);
      }

      document.addEventListener('pointerdown', openFab, true);
      document.addEventListener('click',       openFab, true);
      try {
        document.addEventListener('touchend', openFab, { capture:true, passive:false });
      } catch(_e){
        document.addEventListener('touchend', function(e){ openFab(e); }, true);
      }
    })();

    // Click a size chip → add to cart
    document.addEventListener('click', async (e)=>{
      const chip = _closest(e.target, '.qa-chip');
      if (!chip) return;

      e.preventDefault();
      if (chip.disabled || !chip.dataset.variantId) return;

      try{
        chip.disabled = true;
        const label = chip.textContent;
        await addToCart(chip.dataset.variantId, 1);
        chip.textContent = '✓';
        setTimeout(()=>{ chip.textContent = label; chip.disabled = false; }, 900);

        // Trigger the theme's "added to cart" popup (theme:cart:popdown)
        try {
          document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
            detail: { variant: { id: Number(chip.dataset.variantId) } },
            bubbles: true
          }));
        } catch(_e2){}
      } catch(_e){
        chip.disabled = false;
      }
    }, true);

    // Click outside wrapper → close overlays and re-show FABs
    document.addEventListener('click', (e)=>{
      document.querySelectorAll('.qa-overlay:not([hidden])').forEach(ov=>{
        const wrap = ov.closest('.pg-media-wrap');
        const fab  = wrap ? wrap.querySelector('.qa-fab') : null;
        if (!wrap) return;

        if (!wrap.contains(e.target) && !(fab && fab.contains(e.target))){
          ov.hidden = true; ov.style.opacity=''; ov.style.transform='';
          if (fab){ fab.setAttribute('aria-expanded','false'); fab.hidden = false; }
        }
      });
    });
  })();

  // ---------------------------------------------------------------------------
  // Predictive search: "Search for..." button click → navigate to results
  // The button is role="option" inside the predictive dropdown and the theme's
  // onFormSubmit can prevent navigation, so we handle the click explicitly.
  // ---------------------------------------------------------------------------
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.search__results__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const form = btn.closest('form');
    const input = form && form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    window.location.href = '/search?' + new URLSearchParams({
      q: input.value.trim(),
      type: 'product',
      'options[prefix]': 'last'
    }).toString();
  }, true);

  // ---------------------------------------------------------------------------
  // Clearance bucket click state (NO <script> tags)
  // ---------------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    const buckets = document.querySelectorAll('.clearance-buckets .bucket');
    if (!buckets || !buckets.length) return;

    buckets.forEach(bucket => {
      bucket.addEventListener('click', function () {
        buckets.forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
      });
    });
  });


document.addEventListener("DOMContentLoaded", () => {
  const productRoot = document.querySelector('[data-section-type="product"]');
  if (!productRoot) return;

  const moveCountdown = () => {
    const sizeWrapper = productRoot.querySelector('.selector-wrapper[data-select-label="Size"]');
    if (!sizeWrapper) return;

    const legend = sizeWrapper.querySelector('.radio__legend');
    if (!legend) return;

    const remainingBlock = productRoot.querySelector('.product__block__remaining');
    if (!remainingBlock) return;

    const countdown = remainingBlock.querySelector('p.variant__countdown');
    if (!countdown) return;

    // Move it into the legend (right after the selected size)
    if (!legend.contains(countdown)) legend.appendChild(countdown);

    // Hide the original container after moving countdown out
    remainingBlock.style.display = "none";
  };

  moveCountdown();

  // Re-run when the selected variant changes (catch most themes)
  document.addEventListener("variant:change", moveCountdown);
  document.addEventListener("product:variant-change", moveCountdown);

  // Backup: after choosing a size
  productRoot.addEventListener("change", (e) => {
    if (e.target?.matches('.selector-wrapper[data-select-label="Size"] input[type="radio"]')) {
      setTimeout(moveCountdown, 0);
    }
  });
});





})(); // end main IIFE
